import { PlaylistCheckIcon } from './PlaylistCheckIcon';

/**
 * author: Google
 * id F3E26F6E-9F9A-490B-A28A-1BD32A60D143
 * name playlist-check
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/playlist-check.svg
 * tags
 */
export const PlaylistTickIcon = PlaylistCheckIcon;
export default PlaylistTickIcon